module.exports = __webpack_public_path__ + "img/k04.75f647a8.png";